/**
 * Hero Cinematic Pro Engine V15.4
 * Ottimizzato per performance mobile - Gennaio 2026
 * NOTA: Atmosphere Engine (particelle) rimosso per migliorare performance
 */

(function () {
    // Prevent double loading
    if (window.HcpEngineLoaded) return;
    window.HcpEngineLoaded = true;

    // --- GLOBAL INIT FUNCTION ---
    window.initHeroCinematic = function (sectionId) {
        const root = document.getElementById(`HCP-${sectionId}`);
        if (!root) return;

        const slider = root.querySelector('.hcp-slider');
        const slides = root.querySelectorAll('.hcp-slide');
        const mode = root.dataset.transition;
        const speed = parseInt(root.dataset.speed) || 6000;
        const isDebug = root.classList.contains('hcp-debug-mode');

        // Cleanup Timer
        if (root.dataset.autoTimer) clearInterval(parseInt(root.dataset.autoTimer));
        if (root.dataset.countdownInterval) clearInterval(parseInt(root.dataset.countdownInterval));

        // Cleanup Stale HUD
        const existingHuds = document.querySelectorAll(`#hcp-debug-hud-${sectionId}`);
        existingHuds.forEach(h => {
            if (h.parentElement === document.body) h.remove();
        });

        let currentIdx = 0;
        let autoTimer;
        let isVisible = true;

        // --- COUNTDOWN ENGINE ---
        const initCountdowns = () => {
            const timers = root.querySelectorAll('.hcp-timer-wrapper');
            if (timers.length === 0) return;

            const updateTimers = () => {
                const now = new Date().getTime();
                timers.forEach(timer => {
                    const dateStr = timer.dataset.date;
                    if (!dateStr) return;

                    const targetDate = new Date(dateStr.replace(/-/g, '/')).getTime();
                    if (isNaN(targetDate)) return;

                    const distance = targetDate - now;

                    if (distance < 0) {
                        timer.innerHTML = '<div class="t-expired" style="font-weight:bold; font-size: 0.8em; opacity: 0.8;">SCADUTO</div>';
                        return;
                    }

                    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    const elDays = timer.querySelector('.t-days');
                    const elHours = timer.querySelector('.t-hours');
                    const elMins = timer.querySelector('.t-mins');
                    const elSecs = timer.querySelector('.t-secs');

                    if (elDays) elDays.innerText = String(days).padStart(2, '0');
                    if (elHours) elHours.innerText = String(hours).padStart(2, '0');
                    if (elMins) elMins.innerText = String(minutes).padStart(2, '0');
                    if (elSecs) elSecs.innerText = String(seconds).padStart(2, '0');
                });
            };

            updateTimers();
            const countdownInterval = setInterval(updateTimers, 1000);
            root.dataset.countdownInterval = countdownInterval;
        };
        initCountdowns();

        // --- TRANSITION ENGINE ---
        const goTo = (idx) => {
            if (idx >= slides.length) idx = 0;
            if (idx < 0) idx = slides.length - 1;

            const activeSlide = root.querySelector('.hcp-slide.active');
            const nextSlide = slides[idx];

            // 1. Exiting
            if (activeSlide) {
                activeSlide.classList.remove('active');
                activeSlide.classList.add('exiting');
                setTimeout(() => {
                    activeSlide.classList.remove('exiting');
                }, 600);
            }

            // 2. Reset
            nextSlide.classList.remove('exiting');
            nextSlide.classList.add('hcp-reset');
            void nextSlide.offsetWidth; // Reflow

            // 3. Activate
            requestAnimationFrame(() => {
                nextSlide.classList.remove('hcp-reset');
                nextSlide.classList.add('active');
            });

            if (mode === 'slide' && slider) {
                slider.scrollTo({ left: idx * slider.offsetWidth, behavior: 'smooth' });
            }

            currentIdx = idx;
        };

        const startAuto = () => {
            clearInterval(autoTimer);
            autoTimer = setInterval(() => {
                if (isVisible && !root.classList.contains('hcp-paused')) goTo(currentIdx + 1);
            }, speed);
            root.dataset.autoTimer = autoTimer;
        };

        // --- DEBUGGER ---
        if (isDebug) {
            const hud = root.querySelector(`.hcp-debug-hud`);

            if (hud && hud.parentElement !== document.body) {
                document.body.appendChild(hud);
            }

            const hudX = hud ? hud.querySelector('.hud-x') : null;
            const hudY = hud ? hud.querySelector('.hud-y') : null;
            const playBtn = hud ? hud.querySelector('#hcp-play-toggle') : null;
            const ghostSelect = hud ? hud.querySelector('#hcp-ghost-target') : null;
            const ghostCursor = document.getElementById('hcp-ghost-cursor');

            if (playBtn) {
                playBtn.addEventListener('click', () => {
                    if (root.classList.contains('hcp-paused')) {
                        root.classList.remove('hcp-paused');
                        playBtn.innerText = '⏸ PAUSE SLIDES';
                        playBtn.style.background = '#ffff00';
                        goTo(currentIdx + 1);
                        startAuto();
                    } else {
                        root.classList.add('hcp-paused');
                        playBtn.innerText = '▶ PLAY SLIDES';
                        playBtn.style.background = '#00ffff';
                        clearInterval(autoTimer);
                    }
                });
            }

            root.addEventListener('mousemove', (e) => {
                const rect = root.getBoundingClientRect();
                const rawX = e.clientX - rect.left;
                const rawY = e.clientY - rect.top;

                const x = Math.round((rawX / rect.width) * 100);
                const y = Math.round((rawY / rect.height) * 100);

                if (hudX) hudX.innerText = Math.max(0, Math.min(100, x));
                if (hudY) hudY.innerText = Math.max(0, Math.min(100, y));

                if (ghostCursor && ghostSelect && ghostSelect.value !== 'none') {
                    ghostCursor.style.left = rawX + 'px';
                    ghostCursor.style.top = rawY + 'px';

                    const activeSlide = root.querySelector('.hcp-slide.active');
                    if (activeSlide) {
                        const candidates = activeSlide.querySelectorAll(ghostSelect.value);
                        let targetEl = null;
                        for (const el of candidates) {
                            if (el.offsetWidth > 0 && el.offsetParent !== null) {
                                targetEl = el;
                                break;
                            }
                        }

                        if (targetEl) {
                            ghostCursor.style.width = targetEl.offsetWidth + 'px';
                            ghostCursor.style.height = targetEl.offsetHeight + 'px';
                            ghostCursor.style.display = 'block';
                        } else {
                            ghostCursor.style.display = 'none';
                        }
                    }
                } else if (ghostCursor) {
                    ghostCursor.style.display = 'none';
                }
            });

            root.classList.add('hcp-paused');
            clearInterval(autoTimer);
        } else {
            if (slides.length > 1) startAuto();
        }

        // Ensure active slide
        if (slides.length > 0 && !root.querySelector('.hcp-slide.active')) {
            slides[0].classList.add('active');
        }

        // --- VISIBILITY & RESUME HANDLER (V15.5 FIX) ---
        const handleVisibilityChange = () => {
            if (document.hidden) {
                // APP IN BACKGROUND: FREEZE TOTALE
                isVisible = false;
                clearInterval(autoTimer);
                // Non fermiamo il countdown perché deve rimanere sincrono col tempo reale
            } else {
                // APP IN FOREGROUND: SOFT RESUME
                // Ritardo di 300ms per permettere alla GPU di riallocare le texture
                setTimeout(() => {
                    isVisible = true;
                    if (!root.classList.contains('hcp-paused') && slides.length > 1) {
                        goTo(currentIdx); // Resetta lo stato visivo della slide corrente
                        startAuto(); // Riavvia il loop
                    }
                }, 300);
            }
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);

        // --- EVENT LISTENERS HANDLING ---
        // Remove old listeners to prevent memory leaks (V15.5)
        if (window[`hcpEvents_${sectionId}`]) {
            document.removeEventListener('shopify:block:select', window[`hcpEvents_${sectionId}`].select);
            document.removeEventListener('shopify:block:deselect', window[`hcpEvents_${sectionId}`].deselect);
            document.removeEventListener('visibilitychange', window[`hcpEvents_${sectionId}`].visibility); // Remove old vis listener
        }

        // Define new handling wrappers
        const handleBlockSelect = (e) => {
            if (e.detail.sectionId !== sectionId) return;
            const targetSlide = root.querySelector(`[data-hcp-block-id="${e.detail.blockId}"]`);
            if (targetSlide) {
                const slides = root.querySelectorAll('.hcp-slide');
                slides.forEach(s => s.classList.remove('active'));
                targetSlide.classList.add('active');
                root.classList.add('hcp-paused');
                clearInterval(autoTimer);
            }
        };

        const handleBlockDeselect = (e) => {
            if (e.detail.sectionId !== sectionId) return;
            if (root && !root.classList.contains('hcp-debug-mode')) {
                root.classList.remove('hcp-paused');
                startAuto();
            }
        };

        // Register Global Events Reference
        window[`hcpEvents_${sectionId}`] = {
            select: handleBlockSelect,
            deselect: handleBlockDeselect,
            visibility: handleVisibilityChange
        };

        document.addEventListener('shopify:block:select', handleBlockSelect);
        document.addEventListener('shopify:block:deselect', handleBlockDeselect);

    };
})();
